import type { SensorMode, RfBoostSwitch, KeyScanRate } from '@rapoo/device-sdk'

/**
 * h20_多合一_3950_光微动_光编码器_800mAh
 * @param id 回报率
 * @param modeID 传感器模式
 * @param rfStrengthSwitch 射频策略
 * @param keyScanRate 按键扫描率
 */
export function getBatteryLife_h20_pt0_3950_kt1_rt1_800(
  id: number,
  modeID: SensorMode,
  rfStrengthSwitch: RfBoostSwitch,
  keyScanRate: KeyScanRate,
): string {
  let batteryLife = '100'
  //125
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '540-560'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '455-475'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '355-375'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '240-260'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '485-505'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '405-425'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '310-330'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '210-230'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '530-550'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '450-470'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '350-370'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '240-260'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '470-490'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '395-415'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '305-325'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '205-225'
  }
  //250
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '510-530'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '435-455'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '340-360'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '240-260'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '440-460'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '375-395'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '290-310'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '200-220'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '495-515'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '460-480'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '340-360'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '235-255'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '470-490'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '370-390'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '290-310'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '195-215'
  }
  //500
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '500-520'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '430-450'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '340-360'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '235-255'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '425-445'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '365-385'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '285-305'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '195-215'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '490-510'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '425-445'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '335-355'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '230-250'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '420-440'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '360-380'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '285-305'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '190-210'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '460-480'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '415-435'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '325-345'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '230-250'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '400-420'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '345-365'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '275-295'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '190-210'
  }
  //1000
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '450-470'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '390-410'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '315-335'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '225-245'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '355-375'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '310-330'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '250-270'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '180-200'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '425-445'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '375-395'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '305-325'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '220-240'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '345-365'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '300-320'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '245-265'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '175-195'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '150-170'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '140-160'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '130-150'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '110-130'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '135-155'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '130-150'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '115-135'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '100-120'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '150-170'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '140-160'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '130-150'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '110-130'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '135-155'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '130-150'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '115-135'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '100-120'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '105-125'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '100-120'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '95-115'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '80-100'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '100-120'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '95-115'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '85-105'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '75-95'
  }
  //2000
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '350-370'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '320-340'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '265-285'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '200-220'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '250-270'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '235-255'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '200-220'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '150-170'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '140-160'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '135-155'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '120-140'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '105-125'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '120-140'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '110-130'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '100-120'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '90-110'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '140-160'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '135-155'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '120-140'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '105-125'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '120-140'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '110-130'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '85-105'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '90-110'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '100-120'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '100-120'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '95-115'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '80-100'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '90-110'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '85-105'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '80-100'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '80-100'
  }
  //4000
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '120-140'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '115-135'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '110-130'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '95-115'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '90-110'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '90-110'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '80-100'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '80-100'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '120-140'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '115-135'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '110-130'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '95-115'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '90-110'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '90-110'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '85-105'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '80-90'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '90-110'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '90-110'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '80-100'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '80-90'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '75-85'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '75-85'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '70-80'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '65-75'
  }
  //8000
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '95-115'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '90-110'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '85-105'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '80-100'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '70-80'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '65-75'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '65-75'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '60-70'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '95-115'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '90-110'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '85-105'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '80-100'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '70-80'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '65-75'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '65-75'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '60-70'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '75-95'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '75-95'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '70-90'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '70-80'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '60-70'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '55-65'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '55-65'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '50-60'
  }
  return batteryLife + 'h'
}

/**
 * h20_1T1R_3950_光微动_光编码器_800mAh
 * @param id 回报率
 * @param modeID 传感器模式
 * @param rfStrengthSwitch 射频策略
 * @param keyScanRate 按键扫描率
 */
export function getBatteryLife_h20_pt1_3950_kt1_rt1_800(
  id: number,
  modeID: SensorMode,
  rfStrengthSwitch: RfBoostSwitch,
  keyScanRate: KeyScanRate,
): string {
  let batteryLife = '100'
  //125
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '520-540'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '445-465'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '350-370'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '240-260'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '490-510'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '410-430'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '310-330'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '205-225'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '510-530'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '440-460'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '345-365'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '240-260'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '485-505'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '410-430'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '305-325'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '205-225'
  }
  //250
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '495-515'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '430-450'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '340-360'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '235-255'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '455-475'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '385-405'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '295-315'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '200-220'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '490-510'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '425-445'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '335-355'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '230-250'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '445-465'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '380-400'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '290-310'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '195-215'
  }
  //500
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '455-475'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '400-420'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '320-340'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '225-245'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '390-410'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '340-360'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '265-285'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '185-205'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '450-470'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '395-415'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '320-340'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '225-245'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '390-410'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '335-355'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '260-280'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '180-200'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '430-450'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '380-400'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '310-330'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '220-240'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '370-390'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '320-340'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '255-275'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '180-200'
  }
  //1000
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '385-405'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '350-370'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '290-310'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '210-230'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '380-400'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '270-290'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '220-240'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '160-180'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '380-400'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '335-355'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '280-300'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '205-225'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '290-310'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '170-190'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '215-235'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '160-180'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '140-160'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '135-155'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '120-140'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '105-125'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '125-145'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '120-140'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '110-130'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '90-110'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '140-160'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '135-155'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '120-140'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '105-125'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '125-145'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '120-140'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '110-130'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '90-110'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '100-120'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '100-120'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '90-110'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '85-105'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '90-110'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '90-110'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '80-100'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '75-85'
  }
  //2000
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '290-310'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '270-290'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '230-250'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '180-200'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '200-220'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '190-210'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '160-180'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '125-145'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '125-145'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '120-140'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '110-130'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '95-115'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '105-125'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '100-120'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '90-110'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '80-90'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '125-145'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '120-140'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '110-130'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '95-115'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '105-125'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '100-120'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '90-110'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '80-90'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '90-110'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '90-110'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '85-105'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '80-90'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '80-100'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '80-90'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '75-85'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '65-75'
  }
  //4000
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '105-125'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '100-120'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '95-115'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '80-100'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '80-90'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '80-90'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '75-85'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '65-75'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '105-125'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '100-120'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '95-115'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '80-100'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '80-90'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '80-90'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '75-85'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '65-75'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '80-100'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '80-100'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '75-85'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '70-80'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '65-75'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '65-75'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '60-70'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '55-65'
  }
  //8000
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '75-85'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '75-85'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '75-85'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '70-80'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '50-60'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '50-60'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '45-55'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '45-55'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '75-85'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '75-85'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '75-85'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '70-80'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '50-60'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '50-60'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '45-55'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '45-55'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '65-75'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '65-75'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '60-70'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '60-70'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '45-55'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '45-55'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '40-50'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '40-50'
  }
  return batteryLife + 'h'
}

/**
 * h20_多合一_3950_光微动_光编码器_300mAh
 * @param id 回报率
 * @param modeID 传感器模式
 * @param rfStrengthSwitch 射频策略
 * @param keyScanRate 按键扫描率
 */
export function getBatteryLife_h20_pt0_3950_kt1_rt1_300(
  id: number,
  modeID: SensorMode,
  rfStrengthSwitch: RfBoostSwitch,
  keyScanRate: KeyScanRate,
): string {
  let batteryLife = '100'
  //125
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '195-215'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '165-185'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '125-145'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '85-105'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '175-195'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '145-165'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '110-130'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '75-85'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '190-210'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '160-180'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '125-145'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '85-105'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '170-190'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '140-160'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '110-130'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '75-85'
  }
  //250
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '185-205'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '155-175'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '120-140'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '80-100'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '160-180'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '135-155'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '100-120'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '70-80'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '180-200'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '155-175'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '120-140'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '80-100'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '155-175'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '130-150'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '100-120'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '70-80'
  }
  //500
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '180-200'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '155-175'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '120-140'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '80-100'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '155-175'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '130-150'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '100-120'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '70-80'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '175-195'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '150-170'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '120-140'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '80-100'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '150-170'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '130-150'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '100-120'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '70-80'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '165-185'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '145-165'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '115-135'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '80-100'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '140-160'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '125-145'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '100-120'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '70-80'
  }
  //1000
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '160-180'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '140-160'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '110-130'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '80-100'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '130-150'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '110-130'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '90-110'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '65-75'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '155-175'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '135-155'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '110-130'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '80-90'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '125-145'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '105-125'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '85-105'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '65-75'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '55-65'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '55-65'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '45-55'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '40-50'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '50-60'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '45-55'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '40-50'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '35-45'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '55-65'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '55-65'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '45-55'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '40-50'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '50-60'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '45-55'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '40-50'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '35-45'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '40-50'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '35-45'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '35-45'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '30-40'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '35-45'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '35-45'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '30-40'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '25-35'
  }
  //2000
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '125-145'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '115-135'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '95-115'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '70-90'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '90-110'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '80-100'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '70-80'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '55-65'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '50-60'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '50-60'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '45-55'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '40-50'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '45-55'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '40-50'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '35-45'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '30-40'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '50-60'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '50-60'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '45-55'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '40-50'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '45-55'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '40-50'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '30-40'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '30-40'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '35-45'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '35-45'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '35-45'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '30-40'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '30-40'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '30-40'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '25-35'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '25-35'
  }
  //4000
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '45-55'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '45-55'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '40-50'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '35-45'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '35-45'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '30-40'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '30-40'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '25-35'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '45-55'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '45-55'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '40-50'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '35-45'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '35-45'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '30-40'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '30-40'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '25-35'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '30-40'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '30-40'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '30-40'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '25-35'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '25-35'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '25-35'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '25-35'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '20-30'
  }
  //8000
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '35-45'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '35-45'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '30-40'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '25-35'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '25-35'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '20-30'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '20-30'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '20-30'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '35-45'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '35-45'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '30-40'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '25-35'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '25-35'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '20-30'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '20-30'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '20-30'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '25-35'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '25-35'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '25-35'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '25-35'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '20-30'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '15-25'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '15-25'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '15-25'
  }
  return batteryLife + 'h'
}

/**
 * h20_1T1R_3950_光微动_光编码器_300mAh
 * @param id 回报率
 * @param modeID 传感器模式
 * @param rfStrengthSwitch 射频策略
 * @param keyScanRate 按键扫描率
 */
export function getBatteryLife_h20_pt1_3950_kt1_rt1_300(
  id: number,
  modeID: SensorMode,
  rfStrengthSwitch: RfBoostSwitch,
  keyScanRate: KeyScanRate,
): string {
  let batteryLife = '100'
  //125
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '190-210'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '160-180'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '125-145'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '85-105'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '180-200'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '150-170'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '110-130'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '75-85'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '185-205'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '160-180'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '125-145'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '80-100'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '175-195'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '145-165'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '110-130'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '75-85'
  }
  //250
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '180-200'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '155-175'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '120-140'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '80-100'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '165-185'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '140-160'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '105-125'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '75-85'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '180-200'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '150-170'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '120-140'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '80-100'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '160-180'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '135-155'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '100-120'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '70-80'
  }
  //500
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '165-185'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '145-165'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '115-135'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '80-100'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '140-160'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '120-140'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '90-110'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '65-75'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '160-180'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '140-160'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '110-130'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '80-100'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '140-160'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '120-140'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '90-110'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '65-75'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '155-175'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '135-155'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '110-130'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '80-90'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '135-155'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '115-135'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '90-110'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '65-75'
  }
  //1000
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '140-160'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '125-145'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '100-120'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '75-85'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '135-155'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '95-115'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '80-90'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '60-70'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '140-160'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '120-140'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '100-120'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '70-90'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '100-120'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '90-110'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '80-90'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '55-65'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '50-60'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '50-60'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '45-55'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '35-45'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '45-55'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '45-55'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '40-50'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '30-40'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '50-60'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '50-60'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '45-55'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '35-45'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '45-55'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '45-55'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '40-50'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '30-40'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '35-45'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '35-45'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '30-40'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '30-40'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '35-45'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '30-40'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '30-40'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '25-35'
  }
  //2000
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '110-130'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '95-115'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '80-100'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '65-75'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '75-85'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '70-80'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '60-70'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '45-55'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '45-55'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '45-55'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '40-50'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '35-45'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '35-45'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '35-45'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '30-40'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '25-35'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '45-55'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '45-55'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '40-50'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '35-45'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '35-45'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '35-45'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '30-40'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '25-35'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '30-40'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '30-40'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '30-40'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '25-35'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '30-40'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '25-35'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '25-35'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '20-30'
  }
  //4000
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '35-45'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '35-45'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '35-45'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '30-40'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '25-35'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '25-35'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '25-35'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '20-30'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '35-45'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '35-45'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '35-45'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '30-40'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '25-35'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '25-35'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '25-35'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '20-30'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '25-35'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '25-35'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '25-35'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '25-35'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '20-30'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '20-30'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '20-30'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '15-25'
  }
  //8000
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '25-35'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '25-35'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '25-35'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '25-35'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '15-25'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '15-25'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '15-25'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '15-25'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '25-35'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '25-35'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '25-35'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '25-35'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '15-25'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '15-25'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '15-25'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '15-25'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '20-30'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '20-30'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '20-30'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '20-30'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '15-20'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '15-20'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '15-20'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '15-20'
  }
  return batteryLife + 'h'
}

/**
 * h20_多合一_3955_光微动_光编码器_800mAh
 * @param id 回报率
 * @param modeID 传感器模式
 * @param rfStrengthSwitch 射频策略
 * @param keyScanRate 按键扫描率
 */
export function getBatteryLife_h20_pt0_3955_kt1_rt1_800(
  id: number,
  modeID: SensorMode,
  rfStrengthSwitch: RfBoostSwitch,
  keyScanRate: KeyScanRate,
): string {
  let batteryLife = '100'
  //125
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '540-560'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '455-475'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '355-375'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '240-260'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '485-505'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '405-425'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '310-330'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '210-230'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '530-550'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '450-470'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '350-370'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '240-260'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '470-490'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '395-415'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '305-325'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '205-225'
  }
  //250
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '510-530'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '435-455'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '340-360'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '240-260'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '440-460'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '375-395'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '290-310'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '200-220'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '495-515'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '460-480'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '340-360'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '235-255'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '470-490'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '370-390'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '290-310'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '195-215'
  }
  //500
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '500-520'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '430-450'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '340-360'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '235-255'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '425-445'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '365-385'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '285-305'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '195-215'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '490-510'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '425-445'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '335-355'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '230-250'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '420-440'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '360-380'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '285-305'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '190-210'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '460-480'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '415-435'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '325-345'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '230-250'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '400-420'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '345-365'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '275-295'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '190-210'
  }
  //1000
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '450-470'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '390-410'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '315-335'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '225-245'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '355-375'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '310-330'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '250-270'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '180-200'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '425-445'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '375-395'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '305-325'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '220-240'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '345-365'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '300-320'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '245-265'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '175-195'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '150-170'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '140-160'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '130-150'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '110-130'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '135-155'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '130-150'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '115-135'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '100-120'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '150-170'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '140-160'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '130-150'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '110-130'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '135-155'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '130-150'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '115-135'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '100-120'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '105-125'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '100-120'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '95-115'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '80-100'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '100-120'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '95-115'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '85-105'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '75-95'
  }
  //2000
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '350-370'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '320-340'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '265-285'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '200-220'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '250-270'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '235-255'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '200-220'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '150-170'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '140-160'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '135-155'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '120-140'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '105-125'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '120-140'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '110-130'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '100-120'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '90-110'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '140-160'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '135-155'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '120-140'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '105-125'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '120-140'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '110-130'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '85-105'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '90-110'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '100-120'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '100-120'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '95-115'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '80-100'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '90-110'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '85-105'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '80-100'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '80-100'
  }
  //4000
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '120-140'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '115-135'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '110-130'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '95-115'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '90-110'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '90-110'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '80-100'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '80-100'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '120-140'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '115-135'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '110-130'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '95-115'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '90-110'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '90-110'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '85-105'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '80-90'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '90-110'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '90-110'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '80-100'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '80-90'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '75-85'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '75-85'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '70-80'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '65-75'
  }
  //8000
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '95-115'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '90-110'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '85-105'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '80-100'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '70-80'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '65-75'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '65-75'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '60-70'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '95-115'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '90-110'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '85-105'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '80-100'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '70-80'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '65-75'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '65-75'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '60-70'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '75-95'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '75-95'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '70-90'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '70-80'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '60-70'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '55-65'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '55-65'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '50-60'
  }
  return batteryLife + 'h'
}

/**
 * h20_1T1R_3955_光微动_光编码器_800mAh
 * @param id 回报率
 * @param modeID 传感器模式
 * @param rfStrengthSwitch 射频策略
 * @param keyScanRate 按键扫描率
 */
export function getBatteryLife_h20_pt1_3955_kt1_rt1_800(
  id: number,
  modeID: SensorMode,
  rfStrengthSwitch: RfBoostSwitch,
  keyScanRate: KeyScanRate,
): string {
  let batteryLife = '100'
  //125
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '520-540'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '445-465'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '350-370'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '240-260'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '490-510'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '410-430'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '310-330'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '205-225'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '510-530'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '440-460'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '345-365'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '240-260'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '485-505'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '410-430'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '305-325'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '205-225'
  }
  //250
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '495-515'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '430-450'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '340-360'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '235-255'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '455-475'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '385-405'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '295-315'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '200-220'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '490-510'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '425-445'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '335-355'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '230-250'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '445-465'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '380-400'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '290-310'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '195-215'
  }
  //500
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '455-475'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '400-420'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '320-340'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '225-245'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '390-410'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '340-360'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '265-285'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '185-205'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '450-470'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '395-415'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '320-340'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '225-245'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '390-410'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '335-355'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '260-280'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '180-200'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '430-450'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '380-400'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '310-330'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '220-240'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '370-390'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '320-340'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '255-275'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '180-200'
  }
  //1000
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '385-405'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '350-370'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '290-310'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '210-230'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '380-400'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '270-290'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '220-240'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '160-180'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '380-400'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '335-355'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '280-300'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '205-225'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '290-310'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '170-190'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '215-235'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '160-180'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '140-160'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '135-155'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '120-140'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '105-125'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '125-145'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '120-140'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '110-130'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '90-110'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '140-160'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '135-155'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '120-140'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '105-125'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '125-145'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '120-140'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '110-130'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '90-110'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '100-120'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '100-120'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '90-110'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '85-105'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '90-110'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '90-110'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '80-100'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '75-85'
  }
  //2000
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '290-310'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '270-290'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '230-250'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '180-200'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '200-220'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '190-210'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '160-180'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '125-145'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '125-145'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '120-140'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '110-130'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '95-115'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '105-125'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '100-120'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '90-110'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '80-90'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '125-145'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '120-140'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '110-130'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '95-115'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '105-125'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '100-120'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '90-110'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '80-90'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '90-110'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '90-110'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '85-105'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '80-90'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '80-100'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '80-90'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '75-85'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '65-75'
  }
  //4000
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '105-125'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '100-120'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '95-115'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '80-100'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '80-90'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '80-90'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '75-85'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '65-75'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '105-125'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '100-120'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '95-115'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '80-100'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '80-90'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '80-90'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '75-85'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '65-75'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '80-100'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '80-100'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '75-85'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '70-80'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '65-75'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '65-75'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '60-70'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '55-65'
  }
  //8000
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '75-85'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '75-85'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '75-85'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '70-80'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '50-60'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '50-60'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '45-55'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '45-55'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '75-85'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '75-85'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '75-85'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '70-80'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '50-60'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '50-60'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '45-55'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '45-55'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '65-75'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '65-75'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '60-70'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '60-70'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '45-55'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '45-55'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '40-50'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '40-50'
  }
  return batteryLife + 'h'
}
